<template>
    <v-container class="pt-10 pb-16 page-privacy">
      <v-row justify="center">
        <v-col cols="12" md="10">
          <!-- PAGE TITLE -->
          <h1 class="page-title mb-4">
            SERVICE PARTNER AGREEMENT 
          </h1>
  
        
  
          <!-- 1 -->
          <section>
            <h3>1. THE RELATIONSHIP (PRINCIPAL-TO-PRINCIPAL)</h3>
            <p>
              This Agreement is between Gigvoc Technologies Private Limited
              ("the Platform") and the independent service
              professional/entity ("Service Partner").
            </p>
            <ul>
              <li>
                <strong>Nature of Engagement:</strong>
                The relationship is on a Principal-to-Principal basis. The Service
                Partner is an independent contractor and not an employee, agent,
                or representative of Gigvoc Technologies Pvt Ltd.
              </li>
              <li>
                <strong>Non-Exclusivity:</strong>
                The Service Partner may provide services through other platforms
                or direct clients, provided it does not conflict with active
                OhYes bookings.
              </li>
              <li>
                <strong>Tools & Materials:</strong>
                The Service Partner shall provide all tools, machinery, and
                equipment required to complete assigned tasks.
              </li>
            </ul>
          </section>
  
          <!-- 2 -->
          <section>
            <h3>2. SCOPE OF SERVICES & PRICING</h3>
            <ul>
              <li>
                <strong>Inspection Policy:</strong>
                Prices shown on the app are indicative estimates. The Partner
                must conduct a physical inspection and provide a final,
                itemized quote before starting work.
              </li>
              <li>
                <strong>Mandatory Consent:</strong>
                No work shall be executed without explicit customer approval of
                the final quote.
              </li>
              <li>
                <strong>Platform Fee:</strong>
                Gigvoc Technologies Pvt Ltd will charge a Platform/Lead Fee per
                booking as per the Partner App’s commercial policy.
              </li>
            </ul>
          </section>
  
          <!-- 3 -->
          <section>
            <h3>3. STATUTORY COMPLIANCE & TAXATION</h3>
            <ul>
              <li>
                <strong>GST Compliance:</strong>
                The Service Partner is responsible for GST registration and
                filings where applicable. The Platform may collect and remit
                taxes under Section 9(5) of the CGST Act for notified services.
              </li>
              <li>
                <strong>Identity Verification (KYC):</strong>
                Valid Government ID (Aadhaar, PAN, Trade License) is mandatory
                during onboarding.
              </li>
              <li>
                <strong>Local Regulations:</strong>
                Compliance with municipal laws, building codes, and safety
                regulations is mandatory.
              </li>
            </ul>
          </section>
  
          <!-- 4 -->
          <section>
            <h3>4. DATA PROTECTION (DPDP ACT 2023)</h3>
            <ul>
              <li>
                <strong>Purpose Limitation:</strong>
                Customer data must be used only to fulfill the booked service.
              </li>
              <li>
                <strong>Confidentiality:</strong>
                Customer information shall not be stored, copied, or used for
                marketing or third-party purposes.
              </li>
              <li>
                <strong>Data Deletion:</strong>
                Customer contact details must be deleted from personal devices
                after service completion.
              </li>
            </ul>
          </section>
  
          <!-- 5 -->
          <section>
            <h3>5. QUALITY OF SERVICE & LIABILITY</h3>
            <ul>
              <li>
                <strong>Workmanship:</strong>
                Services must be performed with reasonable skill and care. Any
                service warranty is solely the Partner’s responsibility.
              </li>
              <li>
                <strong>Indemnity:</strong>
                The Partner shall indemnify and hold Gigvoc Technologies Private
                Limited harmless from claims, damages, theft, or losses caused
                during service delivery.
              </li>
              <li>
                <strong>Background Check:</strong>
                The Partner consents to background verification conducted by the
                Platform or authorized agencies.
              </li>
            </ul>
          </section>
  
          <!-- 6 -->
          <section>
            <h3>6. CODE OF CONDUCT & SAFETY</h3>
            <ul>
              <li>
                <strong>Professionalism:</strong>
                Partners must carry valid ID, wear prescribed uniforms (if any),
                and behave professionally.
              </li>
              <li>
                <strong>Public Health Protocols:</strong>
                Compliance with MoHFW guidelines (masking, sanitization) is
                mandatory during health emergencies.
              </li>
              <li>
                <strong>Direct Billing Prohibited:</strong>
                Partners must not solicit off-platform bookings to bypass
                Platform Fees.
              </li>
            </ul>
          </section>
  
          <!-- 7 -->
          <section>
            <h3>7. TERMINATION & SUSPENSION</h3>
            <ul>
              <li>
                <strong>At-Will Termination:</strong>
                Either party may terminate this agreement with seven (7) days’
                notice via the App.
              </li>
              <li>
                <strong>Immediate De-boarding:</strong>
                Gigvoc Technologies Pvt Ltd may suspend or permanently block
                Partners for fraud, repeated complaints, or data privacy
                violations.
              </li>
            </ul>
          </section>
  
          <!-- 8 -->
          <section>
            <h3>8. GOVERNING LAW & ARBITRATION</h3>
            <ul>
              <li>
                <strong>Governing Law:</strong>
                This agreement is governed by the laws of India.
              </li>
              <li>
                <strong>Dispute Resolution:</strong>
                Disputes shall be resolved through arbitration under the
                Arbitration and Conciliation Act, 1996.
              </li>
              <li>
                <strong>Jurisdiction:</strong>
                The seat and venue of arbitration shall be Ernakulam, Kerala.
              </li>
            </ul>
          </section>
  
          <!-- CHECKLIST -->
          <section>
            <h3>Key Checklist for Indian Operations</h3>
            <ul>
              <li>
                Mandatory Aadhaar & PAN upload before Partners go online.
              </li>
              <li>
                Digital training/manual inside the Partner App.
              </li>
              <li>
                Grievance Officer contact accessible within the Partner App.
              </li>
            </ul>
          </section>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "PartnerTermsIndia",
  };
  </script>
  
  <style scoped>
  .page-title {
    font-size: 34px;
    font-weight: 700;
  }
  
  section {
    margin-bottom: 28px;
  }
  
  h3 {
    font-size: 16px;
    font-weight: 600;
    margin-top: 18px;
    margin-bottom: 6px;
  }
  
  p,
  li {
    font-size: 15px;
    color: #444;
    line-height: 1.7;
  }
  
  ul {
    padding-left: 20px;
  }
  </style>
  